/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_500Inputs */

const vi_carrier_status_500 = /** @type {(inputs: Carrier_Status_500Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao bưu tá đi phát`)
};

/**

* @param {Carrier_Status_500Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_500 = /** @type {((inputs?: Carrier_Status_500Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_500Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_500(inputs)
});